import { createFileRoute } from "@tanstack/react-router";

import { NotFoundPage } from "@/components/NotFoundPage";
import { RegionPageView } from "@/components/RegionPageView";
import { getLeadWidgetUrl } from "@/lib/settings.functions";
import { getPublicRegionPage } from "@/lib/region-pages.functions";
import { redirectMissing } from "@/lib/missing-redirect";
import { regionHead } from "@/lib/region-head";

export const Route = createFileRoute("/$topic/$city")({
  loader: async ({ params, location }) => {
    const [result, widget] = await Promise.all([
      getPublicRegionPage({ data: { topic: params.topic, citySlug: params.city } }),
      getLeadWidgetUrl(),
    ]);
    if (!result) return redirectMissing(location.href);
    return { ...result, widgetSrc: widget.url };
  },
  head: ({ loaderData }) =>
    loaderData
      ? regionHead(loaderData)
      : { meta: [{ title: "Seite nicht gefunden – Immobilienwert Online" }, { name: "robots", content: "noindex, follow" }] },
  errorComponent: () => (
    <main className="container-page py-20 text-center">
      <h1 className="text-2xl font-semibold">Seite konnte nicht geladen werden</h1>
    </main>
  ),
  notFoundComponent: NotFoundPage,
  component: () => {
    const { page, nap, widgetSrc, related } = Route.useLoaderData();
    return <RegionPageView page={page} nap={nap} widgetSrc={widgetSrc} related={related} />;
  },
});
